import React from "react";
import { motion } from "framer-motion";
import "../assets/css/PainPoints.css";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Unused
import dashboardImg from "../assets/img/hero/Pain-Points.png";

const PainPoints = () => {
    const features = [
        "Automated, real-time dashboards for all channels",
        "Deep insights into sentiment & audience behavior",
        "Client-ready reports generated in one click",
        "Direct competitor benchmarking & gap analysis"
    ];

    return (
        <section className="feature-block-section" id="pain-points">
            <div className="feature-container">
                {/* Left Side: Image */}
                <motion.div
                    className="feature-image-wrapper"
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <img src={dashboardImg} alt="Analytics Dashboard" className="feature-image" />
                </motion.div>

                {/* Right Side: Dark Content Block */}
                <motion.div
                    className="feature-content-card"
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <div className="content-inner">
                        <h2 className="feature-title">Stop Guessing. <br />Start Growing.</h2>
                        <p className="feature-description">
                            Our AI-powered analytics tools help you build data-driven campaigns based on the topics your audience engages with most.
                        </p>

                        <ul className="feature-list">
                            {features.map((feature, index) => (
                                <li key={index} className="feature-item">
                                    <CheckCircleIcon className="check-icon" />
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>

                        {/* "Notch" Button Container */}
                        <div className="cta-notch-container">
                            <button
                                className="btn-primary"
                                onClick={() => window.location.href = `${process.env.REACT_APP_URL}/auth/register`}
                            >
                                Start Your Free Trial
                            </button>
                        </div>

                        {/* Trust Signals */}
                        <div className="trust-signals">
                            <div className="trust-item">
                                <CheckCircleIcon className="trust-icon" />
                                <span>No card required</span>
                            </div>
                            <div className="trust-item">
                                <CheckCircleIcon className="trust-icon" />
                                <span>Cancel anytime</span>
                            </div>
                            <div className="trust-item">
                                <CheckCircleIcon className="trust-icon" />
                                <span>No contract</span>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default PainPoints;
